/**
 * Transport Modes Constants
 * Re-export from @ra-mr/types for client-side use
 * Additional client-specific utilities can be added here
 */

import { Ship, Truck, Train } from 'lucide-react';
import { TransportMode } from '@ra-mr/types';
import React from 'react';

// Re-export everything from the shared types library
export {
  TRANSPORT_MODES,
  TRANSPORT_MODE_ICONS,
  TRANSPORT_MODE_LABELS,
  TRANSPORT_MODE_LABELS_WITH_ICONS,
  TRANSPORT_MODE_DESCRIPTIONS,
  TRANSPORT_MODE_COLORS,
  TRANSPORT_MODE_BADGE_COLORS,
  isValidTransportMode,
  getTransportModeIcon,
  getTransportModeLabel,
  getTransportModeDescription,
  getTransportModeColor,
  getTransportModeBadgeColor,
} from '@ra-mr/types';

// Re-export TransportMode enum for convenience
export { TransportMode } from '@ra-mr/types';

// React component-based icons for transport modes (lucide-react)
// Use these for consistent icon styling across the application
export const TRANSPORT_MODE_ICON_COMPONENTS: Record<TransportMode, React.ComponentType<{ className?: string }>> = {
  [TransportMode.ocean]: Ship,
  [TransportMode.road]: Truck,
  [TransportMode.rail]: Train,
};

// Get icon component for a transport mode
export function getTransportModeIconComponent(
  mode: string,
  className?: string
): React.ReactNode {
  const IconComponent = TRANSPORT_MODE_ICON_COMPONENTS[mode as TransportMode];
  if (IconComponent) {
    return React.createElement(IconComponent, { className: className || 'w-4 h-4' });
  }
  return null;
}

// Get icon with label as React elements (for tab headers, etc.)
export function getTransportModeLabelWithIcon(
  mode: TransportMode,
  iconClassName?: string
): React.ReactNode {
  const labels: Record<TransportMode, string> = {
    [TransportMode.ocean]: 'Ocean',
    [TransportMode.road]: 'Road',
    [TransportMode.rail]: 'Rail',
  };
  
  const IconComponent = TRANSPORT_MODE_ICON_COMPONENTS[mode];
  return React.createElement(
    'span',
    { className: 'flex items-center gap-1.5' },
    React.createElement(IconComponent, { className: iconClassName || 'w-4 h-4' }),
    labels[mode]
  );
}
